import { ReactNode, useEffect } from 'react';
import Head from 'next/head';
import { Container, Grid, GridItem } from '@chakra-ui/react';

import favicon from '../../public/favicon.ico';
import { IntercomPerformanceOptimized } from '../../lib/intercom';
import Footer from '../Footer/Footer';

import SidebarHeader from './SidebarHeader';
import SidebarContainer from './SidebarContainer';
import Header from '@components/Header/Header';
import { useSegment } from '@lib/segment/SegmentContext';

export default function SidebarLayout({
  children,
  type,
  getStartedLink,
}: {
  children: ReactNode;
  type: 'businesses' | 'engineers';
  getStartedLink?: string;
}) {
  const segment = useSegment();

  useEffect(() => {
    if (segment.canTrackUser) {
      segment.trackPage({
        category: type,
        name: document.title,
      });
    }
  }, [segment, type]);
  return (
    <>
      <Head>
        <link rel="shortcut icon" href={favicon.src} />
      </Head>
      <Header type={type} getStartedLink={getStartedLink} hideBanner />
      <Container maxW={{ lg: '960px', xl: '1344px' }} pr={8}>
        {type == 'engineers' ? <IntercomPerformanceOptimized type={type} /> : <></>}

        <Grid templateColumns={{ base: '1fr', lg: '14.9375rem auto' }}>
          <GridItem>
            <SidebarHeader type={type} />
          </GridItem>
          <GridItem>
            <SidebarContainer type={type}>{children}</SidebarContainer>
          </GridItem>
        </Grid>
      </Container>
      <Footer type={type} />
    </>
  );
}
